
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSnowShowersDayColour as ObiSnowShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-snow-showers-day-colour.js';
 
 
 

 
 export const ObiSnowShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-snow-showers-day-colour',
   elementClass: ObiSnowShowersDayColourElement,
   events: {
     
   }
  });
 
 